import { useEffect } from 'react';

import type { EventHandler } from '../components/eventing-service-provider/eventing-service-provider';
import { useEventBus } from '../components/eventing-service-provider/eventing-service-provider';

export function useEventListener(handler: EventHandler) {
    const eventBus = useEventBus();
    useEffect(() => {
        eventBus.addEventListener(handler);

        return () => {
            eventBus.removeEventListener(handler);
        };
    }, [eventBus, handler]);
}
